import { fetcher } from '@commenda/utils';
import { Country, LegacyDocumentType } from '@prisma/client';

export interface LegacyDocumentParams {
  fileName: string;
  fileUrl: string;
  documentType: LegacyDocumentType;
  serviceRequestTaskId?: number;
  month?: number | null;
  year?: number | null;
  fileNumber?: string | null;
  fileIssuedInJurisdiction?: Country | null;
  fileExpirationDate?: string | null;
  effectiveStartDate?: string | null;
  effectiveEndDate?: string | null;
}

/**
 * Files a service-request task's document under its type, replacing what that type held. The file is
 * picked field by field: callers hold stored file rows too, and the route refuses keys it doesn't take.
 */
const attachLegacyDocument = async (
  businessEntityId: number,
  file: LegacyDocumentParams
) => {
  const body: LegacyDocumentParams = {
    fileName: file.fileName,
    fileUrl: file.fileUrl,
    documentType: file.documentType,
    serviceRequestTaskId: file.serviceRequestTaskId,
    month: file.month,
    year: file.year,
    fileNumber: file.fileNumber,
    fileIssuedInJurisdiction: file.fileIssuedInJurisdiction,
    fileExpirationDate: file.fileExpirationDate,
    effectiveStartDate: file.effectiveStartDate,
    effectiveEndDate: file.effectiveEndDate,
  };

  return fetcher(`business-entities/${businessEntityId}/documents/legacy`, {
    method: 'POST',
    body,
  });
};

export { attachLegacyDocument };
